import { SurveyAnswer } from "./SurveyAnswer"
import { SectionQuestionOption } from "./SectionQuestionOption"

export enum SectionQuestionType {
	TEXT = "text",
	OPTION = "option"
}

interface ContructorParams {
	id?: number
	sectionId?: number
	text?: string
	text_en?: string
	text_ca?: string
	type?: SectionQuestionType
	order?: number
	required?: boolean
	answers?: SurveyAnswer[]
	options?: SectionQuestionOption[]
	enabled?: boolean
}

export class SectionQuestion {
	public readonly id?: number
	public readonly sectionId?: number
	public readonly text?: string
	public readonly text_en?: string
	public readonly text_ca?: string
	public readonly type?: SectionQuestionType
	public readonly order?: number
	public readonly required?: boolean
	public readonly answers?: SurveyAnswer[]
	public readonly options?: SectionQuestionOption[]
	public readonly enabled?: boolean

	constructor(params: ContructorParams) {
		this.id = params.id
		this.sectionId = params.sectionId
		this.text = params.text
		this.text_en = params.text_en
		this.text_ca = params.text_ca
		this.type = params.type
		this.order = params.order
		this.required = params.required
		this.answers = params.answers
		this.options = params.options
		this.enabled = params.enabled
	}
}
